import React from "react"

const pad2 = (n) => String(n).padStart(2, "0")

export default function StepShell({ t, stepKey, current, total, maxWidth = "max-w-2xl", children }) {
  const label = t(`dashboard.onboarding.labels.${stepKey}`)
  const eyebrow = t("dashboard.onboarding.eyebrow", {
    current: pad2(current),
    total: pad2(total),
    label
  })

  return (
    <div className="min-h-screen bg-surface-page">
      <header className="border-b border-rule bg-surface-card">
        <div className="max-w-4xl mx-auto px-9 h-[52px] flex items-center">
          <span className="text-[15px] tracking-[-0.025em]">
            ShopShift<span className="text-ai">.</span>
          </span>
        </div>
      </header>

      <main className={`${maxWidth} mx-auto px-9 py-16`}>
        <p
          className="font-mono text-[10px] tracking-[0.15em] text-ai mb-5"
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          {eyebrow}
        </p>

        <div className="bg-surface-card border border-rule rounded-card p-8">
          {children}
        </div>
      </main>
    </div>
  )
}
